module.exports = __webpack_public_path__ + "./fonts/DMSans-Medium.af17a5.eot";